import Vue from 'vue';

export class Parceiros {

    static create(){
        return {
            nome: null,
            email: null,
            telefone1: null,
            telefone2: null,
            tecnico_externo: false
        };
    }

    /**
     *
     * @param id_parceiro
     * @return {Promise}
     */
    static byPK(id_parceiro){
        return new Promise((ok, fail) => {
            Vue.http.get('parceiros/by-pk/' + id_parceiro)
                .then((res) =>  ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param json
     * @returns {Promise}
     */
    static save(json){
        return new Promise((ok, fail) => {

            let promise = null;

            if (json.id_parceiro){
                promise = Vue.http.put('parceiros/by-pk/'+ json.id_parceiro, json);
            } else {
                promise = Vue.http.post('parceiros/by-pk/0', json);
            }

            promise
                .then((res) => ok(res.data))
                .catch((err) => fail(err));

        });
    }

    /**
     *
     * @param id_parceiro
     * @return {Promise}
     */
    static remove(id_parceiro){
        return new Promise((ok, fail) => {
            Vue.http.delete('parceiros/by-pk/' + id_parceiro)
                .then(() => ok())
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static grid(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/parceiros')
                .then((res) => ok(res.data))
                .catch(() => fail());
        });
    }

    /**
     *
     * @return {Promise}
     */
    static combo(){
        return new Promise((ok, fail) => {
            Vue.http.get('parceiros/combo')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

}
